import { EFinancingProgram } from '@if/core/types'
import { Button } from '@mui/material'
import { reportErrorToConsole } from '@src/services/error-logger'
import { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useCopyLoanAsDraftDialog } from './CopyLoanAsDraftDialog'

interface CopyLoanAsDraftBtnProps {
  financingProgramId: EFinancingProgram
  merchantId: string
  creditApplicationId: string
  disabled?: boolean
}

const CopyLoanAsDraftBtn = ({
  creditApplicationId,
  financingProgramId,
  merchantId,
  disabled = false,
}: CopyLoanAsDraftBtnProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const copyDialog = useCopyLoanAsDraftDialog()

  const handleClick = useCallback(() => {
    copyDialog
      .create({ creditApplicationId, financingProgramId, merchantId })
      .then((copy) => {
        if (copy) navigate(`/Applications/${copy.financingProgramId}/${copy.id}/edit`)
      })
      .catch(reportErrorToConsole)
  }, [copyDialog, creditApplicationId, financingProgramId, merchantId, navigate])

  return (
    <Button variant="outlined" size="large" disabled={disabled} onClick={handleClick}>
      {t('editCreditApplication.copyAsDraft.btn')}
    </Button>
  )
}

export default memo(CopyLoanAsDraftBtn)
